/** Works on older Safari/WebViews that have AbortSignal but no throwIfAborted. */
export function throwIfAborted(signal?: AbortSignal, message = 'Operation cancelled'): void {
  if (signal?.aborted) {
    throw Object.assign(new Error(message), { name: 'AbortError' });
  }
}
